module.exports = __webpack_public_path__ + "static/media/sidebar-people.87bfb787.svg";